import { useWorkspacesList } from "@api/workspace.api";
import { useScope } from "@state/scopeContext.lib";

/**
 * The firm's client workspaces the viewer is assigned to, one cached query
 * for firm Activity's client filter, cells, details and history start. On firm
 * Activity that is every client, since admins and owners are assigned to all
 * of them.
 */
export function useOrganizationClients() {
    const { organizationId } = useScope();
    return useWorkspacesList(organizationId ? { organizationId } : undefined, {
        enabled: !!organizationId,
    });
}
